import { render, staticRenderFns } from "./EntityStubCard.vue?vue&type=template&id=12972d78&scoped=true&"
import script from "./EntityStubCard.vue?vue&type=script&lang=js&"
export * from "./EntityStubCard.vue?vue&type=script&lang=js&"
import style0 from "./EntityStubCard.vue?vue&type=style&index=0&id=12972d78&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12972d78",
  null
  
)

export default component.exports